export default __webpack_public_path__ + "static/media/Mysore_Tomb.042d50f6.jpg";